var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcViewLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5819 12.3085C15.5819 14.2885 13.9819 15.8885 12.0019 15.8885C10.0219 15.8885 8.42188 14.2885 8.42188 12.3085C8.42188 10.3285 10.0219 8.72852 12.0019 8.72852C13.9819 8.72852 15.5819 10.3285 15.5819 12.3085Z",
    stroke: "#F2FBFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0018 20.5793C15.5318 20.5793 18.8218 18.4993 21.1118 14.8993C22.0118 13.4893 22.0118 11.1193 21.1118 9.7093C18.8218 6.1093 15.5318 4.0293 12.0018 4.0293C8.4718 4.0293 5.1818 6.1093 2.8918 9.7093C1.9918 11.1193 1.9918 13.4893 2.8918 14.8993C5.1818 18.4993 8.4718 20.5793 12.0018 20.5793Z",
    stroke: "#F2FBFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcViewLight);
export default __webpack_public_path__ + "static/media/ic_view_light.8b818882e803907378acf481eb2a0c9a.svg";
export { ForwardRef as ReactComponent };